<style>
</style>
<template>
    <v-container fluid id="my--reservations">
        <v-row class="background: secondary">
            <v-container fluid style="max-width: 960px;">
                <v-col class="caption" cols="12">{{ $t('Filtr pro zobrazení') }}</v-col>
                <v-chip-group v-model="filter" column multiple>
                    <v-chip filter value="active" color="primary">{{ $t('Včetně neaktivních') }}</v-chip>
                </v-chip-group>
            </v-container>
        </v-row>
        <v-container fluid style="max-width: 960px;">
            <v-data-table
                    item-key="bookingDate"
                    :loading="loading"
                    :headers="headers"
                    :items="items"
                    class="mt-4 mb-4"
                    single-expand
                    :expanded.sync="expanded"
                    :sort-by="sortBy"
                    :sort-desc="[true, true]"
            >
                <template v-slot:item.sample.validFrom="{ item }">{{
                    item.sample.validFrom | moment('D.M.Y')
                    }}
                </template>
                <template v-slot:item.duration="{ item }">{{ item.sample.validFrom | moment('HH:mm') }} -
                    {{ item.sample.validTo | moment('HH:mm') }}
                </template>
                <template v-slot:item.states="{ item }">
                    <my-reservation-states :expanded="expanded" :item="item"></my-reservation-states>
                </template>

                <template v-slot:expanded-item="{ item }">
                    <td colspan="10" class="elevation-2">
                        <v-row wrap row>
                            <v-col>
                                <small class="grey--text">{{ $t('Aktivita') }}</small>
                                <div>{{ item.sample.reservation.activityName }}</div>
                            </v-col>
                            <v-col>
                                <small class="grey--text">{{ $t('Instruktor') }}</small>
                                <div>{{ item.sample.instructorName }}</div>
                            </v-col>
                            <v-col>
                                <small class="grey--text">{{ $t('Karta') }}</small>
                                <div>{{ item.card.mainRate.name }}</div>
                            </v-col>
                            <v-col>
                                <small class="grey--text">{{ $t('Zóna') }}</small>
                                <div>{{ item.sample.reservation.areaName }}</div>
                            </v-col>
                            <v-col>
                                <small class="grey--text">{{ $t('Služba') }}</small>
                                <div>{{ item.sample.reservation.cardRate.name }}</div>
                            </v-col>
                            <v-col>
                                <small class="grey--text">{{ $t('Stav') }}</small>
                                <my-reservation-states :item="item"></my-reservation-states>
                            </v-col>
                        </v-row>
                    </td>
                </template>
            </v-data-table>
        </v-container>
        <!--  <v-row class="background: grey lighten-1">-->
        <!--    <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
        <!--    <v-alert type="info" color="grey lighten-1">{{ $t('Zde najdete přehled svých rezervací') }}</v-alert>-->
        <!--    </v-container>-->
        <!--  </v-row>-->
    </v-container>
</template>
<script>
import DisplayGroupMixin from '@/mixins/display-group-mixin.js'
import MyReservationStates from '@/components/my-reservation-states.vue'

const moment = require('moment')

export default {
    mixins: [DisplayGroupMixin],
    props: {
        reservations: {
            type: Array,
            default: null
        }
    },
    components: {
        'my-reservation-states': MyReservationStates,
    },
    data() {
        return {
            filter: [],
            expanded: [],
            sortBy: ['sample.validFrom', 'sample.reservation.establishment.establishmentName'],
            headers: [{
                text: 'Datum',
                value: 'sample.validFrom',
                sortable: true
            }, {
                text: 'Čas',
                value: 'duration'
            }, {
                text: 'Provoz',
                value: 'sample.reservation.establishment.establishmentName',
                searchable: true,
                sortable: true
            }, {
                text: 'Služba',
                value: 'sample.reservation.cardRate.name'
            }, {
                text: 'Stav',
                value: 'states'
            }],
            // pagination: {
            //     'sortBy': 'sample.validFrom',
            //     'descending': false,
            //     'rowsPerPage': 10
            // }
        }
    },
    computed: {
        loading() {
            return this.reservations === null
        },
        items() {
            return this.reservations !== null ? this.reservations.filter(item => this.activityFilter(item)) : []
        }
    },
    methods: {
        activityFilter(item) {
            return this.filter.includes('active') || (!item.isCanceled && !item.isUsed && !this.isPast(item))
        },
        isPast(item) {
            return moment().diff(item.sample.validTo) > 0
        }
    }
}
</script>
